import { HandoverInboundIcon, HandoverOutboundIcon, HandoverPendingIcon } from "@/icons";
import { OnlineStatusIndicator } from "./OnlineStatusIndicator";
import { PinnedIndicator } from "./PinnedIndicator";

type FirstColumnContentProps = {
  itemId: string;
  agentId: number;
  isPinned: boolean;
  handoverAllocatedUserId: number | null;
  handoverToUserId: number | null;
  customerName: string;
  customerLastOnlineTime?: string | null;
  isDepartmentView?: boolean;
  showPin?: boolean;
  onTogglePin: (id: string) => void;
};

export const FirstColumnContent = ({
  itemId,
  agentId,
  isPinned,
  handoverAllocatedUserId,
  handoverToUserId,
  customerName,
  customerLastOnlineTime,
  isDepartmentView = false,
  showPin = true,
  onTogglePin,
}: FirstColumnContentProps) => {
  return (
    <div className="flex items-center gap-2 truncate">
      {showPin && !handoverAllocatedUserId && !handoverToUserId && !isDepartmentView && (
        <PinnedIndicator isPinned={isPinned} itemId={itemId} onTogglePin={onTogglePin} />
      )}
      {handoverAllocatedUserId === agentId && !handoverToUserId && (
        <div className="rounded-md bg-slate-100 p-0.5">
          <HandoverPendingIcon />
        </div>
      )}
      {handoverToUserId && handoverToUserId === agentId && (
        <div className="rounded-md bg-sky-100 p-0.5">
          <HandoverInboundIcon />
        </div>
      )}
      {handoverToUserId && handoverToUserId !== agentId && (
        <div className="rounded-md bg-sky-100 p-0.5">
          <HandoverOutboundIcon />
        </div>
      )}
      {customerLastOnlineTime && <OnlineStatusIndicator lastOnlineTime={customerLastOnlineTime} />}
      <span className="truncate" title={customerName}>
        {customerName}
      </span>
    </div>
  );
};
